(function () {
  // 检查活动是否开始
  const now = new Date();

  // 获取 data-start 和 data-end 的时间，并转化为 Date 对象
  const start = new Date($("#bundle_sale").data("start"));
  const end = new Date($("#bundle_sale").data("end"));
  let showButton = "";
  // 判断当前时间是否在开始和结束时间之间
  if (now >= start && now <= end) {
    showButton = "button";
  } else {
    if (start > now) {
      showButton = "comming-soon";
    } else {
      showButton = "end-time";
    }
  }
  if (showButton === "button") {
    $(`#bundle_sale a.${showButton}`).css("display", "flex");
  } else {
    $(`#bundle_sale a.${showButton}`).css("display", "block");
  }

  //默认给第一个标签添加active
  $(".wrapper p:nth-child(1) a, .wrapper span:nth-child(1)").addClass(
    "active_tag"
  );

  //点击不同型号标签来切换价格
  $(".capacity p a").click(function (e) {
    console.log($(this).index(), $(this).attr("data-url"));
    $(this)
      .parents(".capacity")
      .siblings(".button")
      .attr("href", $(this).attr("data-url"));
    $(this).addClass("active_tag");
    $(this).parent().siblings().find("a").removeClass("active_tag");
    $(this)
      .parents(".capacity")
      .siblings("[class^='price_item']")
      .removeClass("price_avtive");
    $(this)
      .parents(".capacity")
      .siblings(`.price_item${$(this).parent().index() + 1}`)
      .addClass("price_avtive");
    return false;
  });

  // 点击不同组合来切换价格和地址
  // 定义组合对象
  let priceData = {
    "1-1": {
      discountPrice: 1724.99,
      save: 125,
      link: "https://tosotdirect.com/products/24000-btu-dual-zone-mini-split-air-conditioner-heat-pump",
    },
    "2-1": {
      discountPrice: 2099.99,
      save: 300,
      link: "https://tosotdirect.com/products/30000-btu-dual-zone-mini-split-air-conditioner-heat-pump",
    },
    "2-2": {
      discountPrice: 2295.99,
      save: 304,
      link: "https://tosotdirect.com/products/30000-btu-tri-zone-mini-split-air-conditioner-heat-pump",
    },
    "3-1": {
      discountPrice: 2479.99,
      save: 220,
      link: "https://tosotdirect.com/products/36000-btu-dual-zone-mini-split-air-conditioner-heat-pump",
    },
    "3-2": {
      discountPrice: 2639.99,
      save: 260,
      link: "https://tosotdirect.com/products/36000-btu-tri-zone-mini-split-air-conditioner-heat-pump",
    },
    "3-3": {
      discountPrice: 2799.99,
      save: 200,
      link: "https://tosotdirect.com/products/36000-btu-quad-zone-mini-split-air-conditioner-heat-pump",
    },
  };
  // 更新价格函数
  const updatePrice = (data) => {
    let discountPriceText = `$${
      String(data.discountPrice).split(".")[0]
    }.<sup>${String(data.discountPrice).split(".")[1]}</sup>`;
    $(".product_item_spetial .price_item1 span:nth-child(1)").html(
      discountPriceText
    );
    $(".product_item_spetial .price_item1 span:nth-child(2)").text(
      `$${data.discountPrice + data.save}`
    );
    $(".product_item_spetial .price_item1 span:nth-child(3)").text(
      `SAVE $${data.save}`
    );
    $(".product_item_spetial .button").attr("href", data.link);
  };
  // 定义搭配组合
  let combination = [, [1], [1, 2], [1, 2, 3]];
  let firstClick = 1;
  let secondClick = combination[1][1];

  // 一层点击逻辑
  $(".product_item_spetial .capacity")
    .first()
    .find("span")
    .click(function () {
      firstClick = $(this).data("index");
      $(this).addClass("active_tag");
      $(this).siblings().removeClass("active_tag");
      // 查找有哪些二级选择
      let secondChoice = combination[firstClick];
      $(".product_item_spetial .capacity")
        .last()
        .find("span")
        .addClass("no-click");
      secondChoice.forEach(function (item) {
        $(".product_item_spetial .capacity")
          .last()
          .find("span:nth-child(" + item + ")")
          .removeClass("no-click");
      });
      // 找到第一个不含 no-click 的元素模拟点击
      $(".product_item_spetial .capacity")
        .last()
        .find("span:not(.no-click)")
        .first()
        .click();
    });

  // 二层点击逻辑
  $(".product_item_spetial .capacity")
    .last()
    .find("span")
    .click(function () {
      if ($(this).hasClass("no-click")) {
        return;
      }
      secondClick = $(this).data("index");
      updatePrice(priceData[`${firstClick}-${secondClick}`]);
      $(this).siblings().removeClass("active_tag");
      $(this).addClass("active_tag");
    });

  // 执行一次一层点击
  $(".product_item_spetial .capacity")
    .first()
    .find("span:nth-child(1)")
    .click();

  // 价格切换逻辑 end

  document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".share-your-work .swiper", {
      slidesPerView: 1,
      loop: true, // 循环播放
      speed: 6000, // 滚动速度，5000ms即5秒
      keyboard: { enabled: true },
      autoplay: {
        delay: 0, // 自动播放不间断
        disableOnInteraction: false, // 用户交互后不停止
      },
      breakpoints: {
        1000: {
          slidesPerView: 1.5,
        },
        2000: {
          slidesPerView: 2,
        },
      },
      pagination: {
        el: ".share-your-work .swiper-pagination",
      },
    });
  });



  // 页面根据url的section参数跳转
  function getUrlParams() {
    var url = window.location.hash;
    if (url == "") {
      return false;
    }
    var className = url.substring(1);
    return className;
  }
  var sectionclass = getUrlParams();
  if (sectionclass) {
    setTimeout(function () {
      $(window).scrollTop($(`.${sectionclass}`).offset().top - 50);
    }, 500);
  }
})();
